import { HttpClient } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import { IonInput, IonModal } from '@ionic/angular';
import { ColumnMode, SelectionType, SortType } from '@swimlane/ngx-datatable';
import { DataService } from 'src/app/data.service';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';

@Component({
  selector: 'app-etkezes',
  templateUrl: './etkezes.component.html',
  styleUrls: ['./etkezes.component.scss'],
})
export class EtkezesComponent  implements OnInit {

  protected readonly ColumnMode = ColumnMode;
  protected readonly SortType = SortType;
  protected readonly JSON = JSON;

  sajatIntezmeny
  intezmeny=2
  dolgozok=0
  tanulok=0
  felulet=0
  import=0
  besorolas=0
  enaplo=0
  dokumentumok=0
  adatszolg=0
  penzugy=0
  modulok=0
  munkatarssorok=[];
  datetime
  alkalmazk
  alkalmazv

  selected = [];
  telepules
  allampolgar
  orszag
  SelectionType = SelectionType;
  allomany
  csoport
  @ViewChild("uzenetmodal") modal: IonModal;
  segment="1"

  portControl: FormControl;
  form: FormGroup;

  constructor(private http: HttpClient,private data: DataService,
    private formBuilder: FormBuilder) {
      this.portControl = this.formBuilder.control(
        {id:142,nev:"magyar"},
        Validators.required
      );
      this.form = this.formBuilder.group({
        anyanyelv: this.portControl,
        allampolgar1: this.portControl,
        allampolgar2: this.portControl,
        alkalmazk: new FormControl("",Validators.required),
        alkalmazv: new FormControl(""),
        orszag: new FormControl({id:142,nev:"Magyarország"},Validators.required)
      }); 
     }

  async ngOnInit() {
    this.sajatIntezmeny = (await this.data.getFromStorage("sajatIntezmeny"))
    
    this.getAllomany();
    this.betoltBeallitas();
    this.idopontBetolt();
  }

  // ----- Menüválasztás módja (havi / napi) és a rendelési határidő -----
  menuValasztas = 'havi';
  /*  A HATÁRIDŐ eddig csak az adatbázisban létezett: a felületen sehol nem lehetett
   *  átírni, pedig ez az egyik legtöbbet kérdezett beállítás. A nap ÉTKEZÉSI NAPOT
   *  jelent – hétvége és szünet nem számít bele –, az óra pedig azon a napon a záró
   *  időpont. */
  zarasNap = 2;
  zarasOra = 12;
  /*  AZ „ELŐTÖLTÉS" GOMB egy kattintással megrendeli a hónap MINDEN étkezési napját
   *  mindenkinek, akinek nyitott étkezési időszaka van. Ahol az alapeset, hogy a
   *  gyerek jár ebédre, ott ez a hónap eleji munka java részét megspórolja – ahol
   *  viszont eseti az étkezés, vagy a szülő rendel, ott ugyanez a gomb egy kattintással
   *  ír felül egy egész hónapot, és utólag kell kézzel visszabontani.
   *  Alapértéke a bekapcsolt állapot: a meglévő telepítéseknél semmi nem változik. */
  elotoltes = true;

  betoltBeallitas() {
    this.http.get<any>('/api/etkezes/beallitas/' + this.sajatIntezmeny.intezmenyId).subscribe({
      next: (r) => {
        this.menuValasztas = r?.menu_valasztas === 'napi' ? 'napi' : 'havi';
        this.zarasNap = Number(r?.zaras_etkezes ?? 2);
        this.zarasOra = Number(r?.zaras_etkezes_ora ?? 12);
        this.elotoltes = r?.elotoltes !== false;
      },
      error: () => { this.menuValasztas = 'havi'; },
    });
  }

  menuValasztasMentes() {
    this.http.put('/api/etkezes/beallitas/' + this.sajatIntezmeny.intezmenyId, {
      menu_valasztas: this.menuValasztas,
      zaras_etkezes: Number(this.zarasNap) || 0,
      zaras_etkezes_ora: Number(this.zarasOra) || 0,
      elotoltes: !!this.elotoltes,
    }).subscribe({
      next: () => this.data.sendToast('Beállítás mentve.', 'success'),
      error: (e) => this.data.sendToast(e?.error?.error || 'A mentés sikertelen.', 'error'),
    });
  }

  /* ----- Napi jelenléti ív: ki jogosult aznap ebédre ----- */
  jelenletiNap = new Date().toISOString().slice(0, 10);
  jelenletiElonezet: any = null;
  jelenletiFut = false;

  jelenletiMegnez() {
    if (!this.jelenletiNap) return;
    this.jelenletiFut = true;
    this.jelenletiElonezet = null;
    this.http.get<any>(`/api/etkezes-rendeles/jelenleti/${this.jelenletiNap}/${this.sajatIntezmeny.intezmenyId}`)
      .subscribe({
        next: (r) => { this.jelenletiElonezet = r; this.jelenletiFut = false; },
        error: (e) => {
          this.jelenletiFut = false;
          this.data.sendToast(e?.error?.error || 'A napi lista nem tölthető be.', 'error');
        },
      });
  }

  /*  A letöltés a kiszolgálóról jön, nem a képernyőn összerakott adatból: így a
   *  fájl mindig a mostani állapotot tartalmazza, és az aláírás-rovat is a helyén van. */
  jelenletiExcel() {
    if (!this.jelenletiNap) return;
    //  Tokenes megnyitás: a linkes `window.open` nem vinné a belépési jegyet.
    this.data.megnyitFajl(
      `/api/etkezes-rendeles/jelenleti-xlsx/${this.jelenletiNap}/${this.sajatIntezmeny.intezmenyId}`,
      'jelenleti.xlsx');
  }


  getRowClass = (row) => {
    return {
      'row-color-blue': row.priority == 1,
      'row-color-green': row.priority == 2,
      'row-color-orange': row.priority == 3,
      'row-color-red': row.priority == 4,
    };
  }

  /* ── Étkezőhely (beszállító) szerkesztő ── */

  // A modal űrlapja. Külön mező, nem a FormGroup: az a régi állomány-adatlaphoz készült.
  helyForm: any = { id: null, nev: '', ar: 0, laktoz: false, gluten: false, laktoz_felar: 0, gluten_felar: 0 };

  /** Üres űrlap az „Új" gombhoz. A gomb a modal triggerét is elsüti, ezért csak töltünk. */
  ujHely() {
    this.helyForm = { id: null, nev: '', ar: 0, laktoz: false, gluten: false, laktoz_felar: 0, gluten_felar: 0 };
  }

  /** Meglévő étkezőhely betöltése szerkesztésre. */
  initModal(id) {
    const hely = (this.allomany || []).find((h: any) => String(h.id) === String(id));
    this.helyForm = hely
      ? {
          id: hely.id, nev: hely.nev || '', ar: Number(hely.ar) || 0,
          laktoz: !!Number(hely.laktoz), gluten: !!Number(hely.gluten),
          laktoz_felar: Number(hely.laktoz_felar) || 0,
          gluten_felar: Number(hely.gluten_felar) || 0,
        }
      : { id: null, nev: '', ar: 0, laktoz: false, gluten: false, laktoz_felar: 0, gluten_felar: 0 };
    this.modal.present();
  }

  async helyMentes() {
    if (!this.helyForm.nev?.trim()) {
      this.data.sendToast('Add meg a beszállító nevét.', 'warning');
      return;
    }
    const test = {
      nev: this.helyForm.nev.trim(),
      ar: Number(this.helyForm.ar) || 0,
      laktoz: this.helyForm.laktoz ? 1 : 0,
      gluten: this.helyForm.gluten ? 1 : 0,
      laktoz_felar: this.helyForm.laktoz ? (Number(this.helyForm.laktoz_felar) || 0) : 0,
      gluten_felar: this.helyForm.gluten ? (Number(this.helyForm.gluten_felar) || 0) : 0,
    };
    const keres = this.helyForm.id
      ? this.http.put('/api/etkezes/hely/' + this.helyForm.id, test)
      : this.http.post('/api/etkezes/hely/' + this.sajatIntezmeny.intezmenyId, test);
    keres.subscribe({
      next: () => {
        this.data.sendToast(this.helyForm.id ? 'Étkezőhely módosítva.' : 'Étkezőhely felvéve.', 'success');
        this.modal.dismiss();
        this.getAllomany();
      },
      error: (e) => this.data.sendToast(e?.error?.error || 'A mentés nem sikerült.', 'error'),
    });
  }

  /** Törlés. A szerver megtagadja, ha menü, időszak vagy tanuló hivatkozik rá. */
  helyTorles(hely: any) {
    if (!confirm(`Törlöd a(z) „${hely?.nev}" étkezőhelyet?`)) return;
    this.http.delete('/api/etkezes/hely/' + hely.id).subscribe({
      next: () => { this.data.sendToast('Étkezőhely törölve.', 'success'); this.getAllomany(); },
      error: (e) => this.data.sendToast(e?.error?.error || 'A törlés nem sikerült.', 'error'),
    });
  }
  onSelect({ selected }) {
    console.log('Select Event', selected, this.selected);

    this.selected.splice(0, this.selected.length);
    this.selected.push(...selected);
  }

  getEletut(){
    this.http
    .get(
      'https://merfoldkovek.oh.gov.hu/api/User/Timeline',
      {
        
      }
    )
    .subscribe({
      next: (response) => {
        //this.allomany = response
        console.log(response)
      },
      error: (error) => {
        console.error('Error fetching data:', error);
/*
{
    "allapot": "NincsMegFeliratkozva",
    "formatumVerzio": 1,
    "generalva": "0001-01-01T00:00:00",
    "adatok": null,
    "adatAllapot": "OsszeallitasAlatt",
    "leiratkozasOka": "Oktazonvaltozas",
    "leiratkozva": null,
    "letrehozva": null,
    "megtekintveUgyintezokent": false,
    "ugyintezoOktazon": null,
    "isSucceeded": true,
    "reasonOfFail": null,
    "muveletAzonosito": "67155014-3c68-47cc-802d-a68aee09ce1c",
    "errorCode": 0,
    "errorCodeString": "0000",
    "time": "2025-01-17T16:35:45.4874766+01:00"
} */
      },
    });
  }

  getAllomany(){
    let headers={
      intezmeny: this.sajatIntezmeny.intezmenyId
    }
    this.http
      .get(
        '/api/etkezes/hely/'+this.sajatIntezmeny.intezmenyId,
        {
          headers: headers,
        }
      )
      .subscribe({
        next: (response: any) => {
          this.allomany = response;
          (this.allomany || []).forEach((h: any) => this.betoltMenuk(h.id));
          this.kuldesAllapotBetolt();
        },
        error: (error) => {
          console.error('Error fetching data:', error);

        },
      });
  }



  // ----- Étkezési menük kezelése (étkezőhelyenként) -----
  menukByHely: { [hely: string]: any[] } = {};
  ujMenu: { [hely: string]: any } = {};

  betoltMenuk(hely: string) {
    this.http.get<any[]>('/api/etkezes/menu/' + hely).subscribe({
      next: (rows) => { this.menukByHely[hely] = rows || []; },
      error: () => { this.menukByHely[hely] = []; },
    });
  }

  ujMenuModel(hely: string) {
    if (!this.ujMenu[hely]) {
      this.ujMenu[hely] = { nev: '', ar: 0, sorrend: 0 };
    }
    return this.ujMenu[hely];
  }

  menuHozzaad(hely: any) {
    const m = this.ujMenuModel(hely.id);
    if (!m.nev) { this.data.sendToast('Adj meg menü nevet!', 'error'); return; }
    this.http.post('/api/etkezes/menu', {
      etkezes_helye: hely.id,
      intezmeny: this.sajatIntezmeny.intezmenyId,
      nev: m.nev, ar: m.ar, sorrend: m.sorrend,
    }).subscribe({
      next: () => {
        this.data.sendToast('Menü hozzáadva.', 'success');
        this.ujMenu[hely.id] = { nev: '', ar: 0, sorrend: 0 };
        this.betoltMenuk(hely.id);
      },
      error: () => this.data.sendToast('A hozzáadás sikertelen.', 'error'),
    });
  }

  // ----- Rendelés kiküldése a beszállítónak -----
  elonezet: { [hely: string]: any } = {};

  /* ── Osztályok tálalási sorrendje ──────────────────────────────────────────
   *
   *  A TURNUS a sorrend-szám. Több osztály kaphatja UGYANAZT: két épületben
   *  egyszerre ebédelnek, és a konyhának egy turnusként kell látnia. Ezért az
   *  időpont a TURNUSHOZ tartozik, nem az osztályhoz – így nem fordulhat elő,
   *  hogy egy turnuson belül két különböző időpont áll.
   */
  idopont: any = null;
  idopontFut = false;

  idopontTanev: number | null = null;

  /*  CSAK TÉNYLEGES TANÉV-VÁLTÁSRA TÖLTÜNK ÚJRA (javítás, 2026-10-08). A betöltés maga állítja be
   *  a választó értékét; ha a választó erre is jelzett, a lista végtelenül újratöltődött – a
   *  turnus-mezőkbe nem lehetett írni, a lap „lefagyott”. Ugyanarra a tanévre nem kérünk újra,
   *  és amíg egy betöltés fut, újat sem indítunk. */
  tanevValt(ertek: any) {
    const tanev = Number(ertek);
    if (!Number.isFinite(tanev) || tanev === Number(this.idopontTanev) || this.idopontFut) return;
    this.idopontBetolt(tanev);
  }

  idopontBetolt(tanev: number | null = null) {
    if (!this.sajatIntezmeny?.intezmenyId) return;
    this.idopontFut = true;
    const q = tanev ? '?tanev=' + tanev : '';
    this.http.get<any>('/api/etkezes-rendeles/idopont/' + this.sajatIntezmeny.intezmenyId + q)
      .subscribe({
        next: (r) => { this.idopont = r; this.idopontTanev = r?.tanev ?? null; this.idopontFut = false; this.turnusSzamol(); },
        error: (e) => {
          this.idopontFut = false;
          this.data.sendToast(e?.error?.error || 'A tálalási sorrend nem tölthető be.', 'error');
        },
      });
  }

  /*  A TURNUSOK ELTÁROLVA, NEM GETTERBŐL (javítás, 2026-10-08). A getter minden
   *  változásérzékeléskor ÚJ objektumokat gyártott; az *ngFor ezért minden körben újraépítette
   *  a benne lévő ion-input mezőket, azok újra jeleztek, és a lap végtelen körbe – lefagyásba –
   *  futott. Most csak akkor számoljuk újra, ha a beosztás tényleg változik. */
  turnusok: any[] = [];
  beosztatlanok: any[] = [];

  private turnusSzamol() {
    this.turnusok = this.turnusLista();
    this.beosztatlanok = (this.idopont?.osztalyok || []).filter((o: any) => !Number(o.sorrend));
  }

  trackTurnus = (_: number, t: any) => t.sorrend;
  trackOsztaly = (_: number, o: any) => o.id;

  /** A turnusok a beosztott osztályokból állnak össze; a beosztatlanok külön csoportban. */
  private turnusLista(): any[] {
    const map = new Map<number, any>();
    for (const o of (this.idopont?.osztalyok || [])) {
      const sz = Number(o.sorrend);
      if (!Number.isFinite(sz) || sz <= 0) continue;
      if (!map.has(sz)) map.set(sz, { sorrend: sz, ido: '', osztalyok: [] });
      const t = map.get(sz);
      t.osztalyok.push(o);
      if (!t.ido && o.ido) t.ido = o.ido;
    }
    return [...map.values()].sort((a, b) => a.sorrend - b.sorrend);
  }

  /** A turnus időpontja MINDEN benne lévő osztályra ráíródik – egy turnus, egy időpont. */
  turnusIdo(t: any, ertek: any) {
    const ido = String(ertek ?? '');
    if (ido === t.ido) return;            // ugyanaz az érték: ne indítson újabb kört
    t.ido = ido;
    for (const o of t.osztalyok) o.ido = ido;
  }

  /*  Turnus-váltáskor az osztály átveszi a CÉL turnus időpontját. Enélkül a régi
   *  időpontját vinné magával, és a turnuson belül két érték lenne – pont az, amit
   *  a turnus-alapú szerkesztés meg akar előzni. */
  osztalyTurnus(o: any, ertek: any) {
    const sz = Number(ertek);
    const uj = Number.isFinite(sz) && sz > 0 ? sz : null;
    if (uj === (o.sorrend == null ? null : Number(o.sorrend))) return;   // nem változott
    o.sorrend = uj;
    if (!o.sorrend) { o.ido = ''; this.turnusSzamol(); return; }
    const cel = this.turnusok.find((t) => t.sorrend === o.sorrend && t.ido);
    o.ido = cel ? cel.ido : (o.ido || '');
    this.turnusSzamol();
  }

  idopontMentes() {
    if (!this.idopont) return;
    this.idopontFut = true;
    this.http.put<any>('/api/etkezes-rendeles/idopont/' + this.sajatIntezmeny.intezmenyId, {
      sorok: (this.idopont.osztalyok || []).map((o: any) => ({
        osztaly: o.id, sorrend: o.sorrend, ido: o.ido,
      })),
    }).subscribe({
      next: (r) => {
        this.data.sendToast(`Mentve: ${r.irt} osztály beosztva, ${r.torolt} beosztás törölve.`, 'success');
        this.idopontBetolt(this.idopontTanev);
      },
      error: (e) => {
        this.idopontFut = false;
        this.data.sendToast(e?.error?.error || 'A mentés nem sikerült.', 'error');
      },
    });
  }

  /*  AZ AUTOMATIKUS KIKÜLDÉS ÁLLAPOTA – amit az ütemező lát. Ha az időzített küldés
   *  elmarad, itt derül ki, miért (hiányzó beállítás, még nem jött el az idő, nincs
   *  holnapra rendelés, hiba, vagy maga az ütemező nem fut). */
  kuldesAllapot: any = {};
  utemezoAllapot: any = null;

  kuldesAllapotBetolt() {
    if (!this.sajatIntezmeny?.intezmenyId) return;
    this.http.get<any>('/api/etkezes-rendeles/allapot/' + this.sajatIntezmeny.intezmenyId).subscribe({
      next: (r) => {
        this.kuldesAllapot = {};
        for (const h of r?.helyek || []) this.kuldesAllapot[h.id] = h;
        this.utemezoAllapot = r?.utemezo || null;
      },
      error: () => { /* az állapotsor rejtve marad */ },
    });
  }

  kuldesAllapotSzoveg(a: any): string {
    if (!a) return '';
    const nap = a.datum ? a.datum.replace(/-/g, '. ') + '.' : '';
    switch (a.allapot) {
      case 'nincs-csatorna': return 'Nincs automatikus kiküldés: hiányzik a csatorna vagy a címzett.';
      case 'nincs-idopont': return 'Nincs automatikus kiküldés: nincs megadva időpont.';
      case 'rossz-idopont': return `Az időpont nem értelmezhető („${a.uk_ora}”) – add meg ÓÓ:PP alakban és mentsd.`;
      case 'kiment': return `A ${nap} napi rendelés már kiment.`;
      case 'nincs-rendeles': return `A ${nap} napra nincs rendelés – nem megy levél.`;
      case 'varakozik': return `A ${nap} napi rendelés (${a.holnapi_adag} adag) ma ${a.uk_ora}-kor megy ki automatikusan.`;
      case 'esedekes': return `A ${nap} napi rendelés (${a.holnapi_adag} adag) esedékes – a következő percben kimegy.`;
      default: return '';
    }
  }

  kuldesAllapotSzin(a: any): string {
    if (!a) return 'medium';
    if (['kiment', 'varakozik'].includes(a.allapot)) return 'success';
    if (['nincs-rendeles'].includes(a.allapot)) return 'medium';
    return 'warning';
  }

  kuldesBeallitasMentes(hely: any) {
    this.http.put('/api/etkezes-rendeles/beallitas/' + hely.id, {
      uzenetkuldes: hely.uzenetkuldes || null,
      uk_helye: hely.uk_helye || null,
      uk_ora: hely.uk_ora || null,
    }).subscribe({
      next: (r: any) => {
        hely.uk_ora = r.uk_ora;
        this.data.sendToast('Kiküldési beállítás mentve.', 'success');
        this.kuldesAllapotBetolt();
      },
      error: (e) => this.data.sendToast(e?.error?.error || 'A mentés sikertelen.', 'error'),
    });
  }

  rendelesElonezet(hely: any) {
    this.http.get<any>('/api/etkezes-rendeles/osszesito/' + this.sajatIntezmeny.intezmenyId + '?hely=' + hely.id)
      .subscribe({
        next: (r) => {
          const sor = (r.beszallitok || []).find((b: any) => b.hely == hely.id);
          this.elonezet[hely.id] = sor || { datum: r.datum, osszes: 0, menuk: [] };
        },
        error: (e) => this.data.sendToast(e?.error?.error || 'Az előnézet nem érhető el.', 'error'),
      });
  }

  rendelesKuldes(hely: any) {
    if (!confirm('Kiküldöd a következő napi rendelést a(z) ' + hely.nev + ' részére?')) return;
    this.http.post<any>('/api/etkezes-rendeles/kuldes/' + this.sajatIntezmeny.intezmenyId, { hely: hely.id })
      .subscribe({
        next: (r) => {
          const e = (r.eredmeny || [])[0];
          if (!e) this.data.sendToast('Erre a napra nincs rendelés.', 'error');
          else if (e.statusz === 'ok') this.data.sendToast(`Kiküldve: ${e.adagok} adag (${e.cimzett}).`, 'success');
          else this.data.sendToast(e.uzenet || 'Nem sikerült kiküldeni (' + e.statusz + ').', 'error');
          this.kuldesAllapotBetolt();
        },
        error: (e) => this.data.sendToast(e?.error?.error || 'A kiküldés sikertelen.', 'error'),
      });
  }

  menuMentes(m: any) {
    this.http.put('/api/etkezes/menu/' + m.id, m).subscribe({
      next: () => this.data.sendToast('Menü mentve.', 'success'),
      error: () => this.data.sendToast('A mentés sikertelen.', 'error'),
    });
  }

  menuTorles(m: any, hely: string) {
    this.http.delete('/api/etkezes/menu/' + m.id).subscribe({
      next: () => { this.data.sendToast('Menü törölve.', 'success'); this.betoltMenuk(hely); },
      error: () => this.data.sendToast('A törlés sikertelen.', 'error'),
    });
  }

  cancel() {
    this.modal.dismiss(null, 'cancel');
  }
  confirm(draft) {

    
  }

  selectChangedAnyanyelv(e){

  }

}
